import React from 'react';

const MobileEmptyState = ({
  icon,
  title,
  message,
  action,
  actionLabel,
  onAction,
}) => {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-12 text-center">
      {icon && (
        <div className="w-16 h-16 rounded-2xl bg-gray-100 dark:bg-gray-800 flex items-center justify-center mb-4">
          {icon}
        </div>
      )}
      <h3 className="font-display text-base font-bold text-gray-900 dark:text-white mb-1.5">
        {title}
      </h3>
      <p className="text-sm text-gray-500 dark:text-gray-400 max-w-xs leading-relaxed mb-4">
        {message}
      </p>
      {(action || (onAction && actionLabel)) && (
        action ? action : (
          <button
            onClick={onAction}
            className="inline-flex items-center px-5 py-2.5 text-sm font-semibold rounded-xl bg-primary text-white hover:bg-primary-dark active:scale-[0.98] transition-all duration-150"
          >
            {actionLabel}
          </button>
        )
      )}
    </div>
  );
};

export default MobileEmptyState;
